// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".associated-options[data-v-04a006fb]{display:flex}.associated-options[data-v-04a006fb] .help-button{margin-top:2px}.requiredColor.v-text-field--outlined fieldset[data-v-04a006fb]{color:red!important}", ""]);
// Exports
module.exports = exports;
